import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTrendingCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trending-circle"} maskId="square-filled-radius-0-stroke-1-IconTrendingCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM13 9H17V13H16V10.7071L12 14.7071L10 12.7071L7.25 15.4571L6.54289 14.75L10 11.2929L12 13.2929L15.2929 10H13V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTrendingCircle;
